import { render, staticRenderFns } from "./SectionsAndItems.vue?vue&type=template&id=44fe4720&scoped=true"
import script from "./SectionsAndItems.vue?vue&type=script&lang=js"
export * from "./SectionsAndItems.vue?vue&type=script&lang=js"
import style0 from "./SectionsAndItems.vue?vue&type=style&index=0&id=44fe4720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fe4720",
  null
  
)

export default component.exports